declare global {
  interface Window {
    fbq: any
  }
}

export const trackFacebookEvent = (event: string, data?: Record<string, any>): Promise<void> => {
  return new Promise((resolve) => {
    if (window.fbq) {
      window.fbq('track', event, data)
    }
    // Simula um pequeno atraso para garantir que o evento seja registrado
    setTimeout(resolve, 500)
  })
}

export const trackFacebookCustomEvent = (event: string, data?: Record<string, any>): Promise<void> => {
  return new Promise((resolve) => {
    if (window.fbq) {
      window.fbq('trackCustom', event, data)
    }
    // Simula um pequeno atraso para garantir que o evento seja registrado
    setTimeout(resolve, 500)
  })
}
